import { Card, CardContent } from "@/components/ui/card";

export function VueltaSummaryCards({ v1BasePoints, v1SecPoints, v2BasePoints, v2SecPoints, totalBasePoints, totalSecondaryPoints, baseWins, tie, overallResult, hasDoubles }) {
  return (
    <div className="grid grid-cols-3 gap-3 mb-6">
      {/* Vuelta 1 */}
      <Card className="card-default overflow-hidden">
        <CardContent className="p-3 text-center">
          <p className="text-xs font-semibold text-[#64748B] mb-2">1ra Vuelta</p>
          <div className="flex items-center justify-center gap-2">
            <span className="text-lg font-bold text-[#1B4D3E]">{v1BasePoints}</span>
            <span className="text-xs text-[#64748B]">-</span>
            <span className="text-lg font-bold text-[#D4A373]">{v1SecPoints}</span>
          </div>
          <p className={`text-xs mt-1 font-medium ${v1BasePoints > v1SecPoints ? 'text-[#1B4D3E]' : v1SecPoints > v1BasePoints ? 'text-[#D4A373]' : 'text-[#64748B]'}`}>
            {v1BasePoints > v1SecPoints ? 'Base' : v1SecPoints > v1BasePoints ? 'Sec.' : 'Empate'}
          </p>
        </CardContent>
      </Card>

      {/* Vuelta 2 */}
      <Card className="card-default overflow-hidden">
        <CardContent className="p-3 text-center">
          <p className="text-xs font-semibold text-[#64748B] mb-2">
            2da Vuelta
            {hasDoubles && (
              <span className="ml-1 text-[10px] bg-amber-100 text-amber-700 px-1 py-0.5 rounded">x2</span>
            )}
          </p>
          <div className="flex items-center justify-center gap-2">
            <span className="text-lg font-bold text-[#1B4D3E]">{v2BasePoints}</span>
            <span className="text-xs text-[#64748B]">-</span>
            <span className="text-lg font-bold text-[#D4A373]">{v2SecPoints}</span>
          </div>
          <p className={`text-xs mt-1 font-medium ${v2BasePoints > v2SecPoints ? 'text-[#1B4D3E]' : v2SecPoints > v2BasePoints ? 'text-[#D4A373]' : 'text-[#64748B]'}`}>
            {v2BasePoints > v2SecPoints ? 'Base' : v2SecPoints > v2BasePoints ? 'Sec.' : 'Empate'}
          </p>
        </CardContent>
      </Card>

      {/* Total */}
      <Card className={`card-default overflow-hidden ${!tie && 'winner-highlight'}`}>
        <CardContent className="p-3 text-center">
          <p className="text-xs font-semibold text-[#64748B] mb-2">Total</p>
          <div className="flex items-center justify-center gap-2">
            <span className="text-lg font-bold text-[#1B4D3E]">{totalBasePoints}</span>
            <span className="text-xs text-[#64748B]">-</span>
            <span className="text-lg font-bold text-[#D4A373]">{totalSecondaryPoints}</span>
          </div>
          <p className={`text-xs mt-1 font-medium ${baseWins && !tie ? 'text-[#1B4D3E]' : !baseWins && !tie ? 'text-[#D4A373]' : 'text-[#64748B]'}`}>
            {tie ? 'Empate' : baseWins ? `Base +${overallResult}` : `Sec. +${Math.abs(overallResult)}`}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
